'use strict';

function KirkleesCareAssessmentService(constants, fieldDefinitionService, numberUtils, careAssessmentService) {

  this.calculateUniversalCreditIncome = function (ucAllowances) {
    var universalCreditIncome = {
      name: 'universalCredit',
      amount: 0,
      weeklyAmount: 0
    };

    if (ucAllowances) {
      var universalCreditTotal = numberUtils.sumArgs(
        ucAllowances.standardAllowance,
        ucAllowances.carer,
        ucAllowances.limitedWorkCapability,
        ucAllowances.limitedWorkAndRelatedCapability);

      universalCreditTotal -= numberUtils.sumArgs(
        ucAllowances.other,
        ucAllowances.earnings,
        ucAllowances.capitalTariff,
        ucAllowances.benefitLimit);

      universalCreditTotal = Math.max(universalCreditTotal, 0);
      var weeklyUniversalCredit = careAssessmentService.toWeeklyAmount(universalCreditTotal, 'Monthly');

      universalCreditIncome.amount = universalCreditTotal;
      universalCreditIncome.weeklyAmount = weeklyUniversalCredit;
    }

    return universalCreditIncome;
  };

  this.getDisabilityLevel = function (userData) {
    var allLevels = constants.levels;
    var attendanceAllowance = userData.getWeeklyIncome('attendanceAllowance');
    return attendanceAllowance === constants.attendanceAllowance.high.amount ? allLevels.high :
      !attendanceAllowance ? allLevels.low : allLevels.medium;
  };

  this.searchPlaTable = function (plaTable, ageLevel, disabilityLevel) {
    return _.find(plaTable, function (plaCategory) {
      return plaCategory.age === ageLevel && plaCategory.disabled === disabilityLevel;
    }).value;
  };

  /**
   * @param workingsFieldsOverrides
   * @return {object} json schema which is of nonResidential type by default
   */
  this.careTypeSchema = function (workingsFieldsOverrides) {

    // Although most of these fields are numeric, some of them can be assigned string values, e.g.
    // migShortfall and totalIncome. To accommodate these, they are all given a string type in the schema
    // and the numeric values are converted to strings before they are stored in the ASF model
    function workingField(overrides) {
      return angular.extend({type: 'string', readOnly: true}, overrides);
    }

    var workingsFields = angular.extend({
      ageLevel: workingField({
        title: 'Age Band',
        'x-schema-form': {
          description: 'Your personal living allowance varies according to your age band'
        }
      }),
      capitalTariff: workingField({
        title: 'Capital Tariff',
        'x-schema-form': {
          description: 'For capital between £14,250 and £23,250: £1 per week for every £250 you have over £14,250 is counted as income. Your charge is based on your weekly income and any capital above £14,250',
          fieldAddonLeft: '£'
          }
      }),
      totalCapital: workingField({
        title: 'Total Savings / Capital',
        'x-schema-form': {
          fieldAddonLeft: '£'
        }
      }),
      universalCreditIncome: workingField({
        title: 'Universal Credit Income',
        'x-schema-form': {
          description: 'Weekly eligible universal credit income',
          fieldAddonLeft: '£'
        }
      }),
      grossIncome: workingField({
        title: 'Gross Income',
        'x-schema-form': {
          description: 'This is the total amount of your income',
          fieldAddonLeft: '£'
        }
      }),
      disregards: workingField({
        title: 'Total Income Disregards',
        'x-schema-form': {
          description: 'This is income that we do not take into account in your financial assessment',
          fieldAddonLeft: '£'
        }
      }),
      totalCosts: workingField({
        title: 'Total Weekly Outgoings Per Person',
        'x-schema-form': {
          description: 'This is the amount allowed for your household expenses',
          fieldAddonLeft: '£'
        }
      }),
      netIncome: workingField({
        title: "Net Income",
        'x-schema-form': {
          description: 'This is your total income minus your disregarded income and any allowable weekly outgoings',
          fieldAddonLeft: '£'
        }
      }),
      personalLivingAllowance: workingField({
        title: 'Personal Living Allowance',
        'x-schema-form': {
          description: 'This is the weekly amount the government says you need to live on',
          fieldAddonLeft: '£'
        }
      }),

      // this field is not required as the applicant may not have a partner
      partnerMIG: workingField({
        title: "Partner's MIG Allowance",
        'x-schema-form': {
          description: "This is the difference between your partner's actual income and the amount the government says they need to live on",
          fieldAddonLeft: '£'
        }
      })
    }, workingsFieldsOverrides);

    return {
      type: 'object',
      properties: {
        isActualCostKnown: fieldDefinitionService.boolean.checkboxSchema(),
        maxContribution: {
          type: 'number',
          minimum: 0,
          'x-schema-form': {
            fieldAddonLeft: '£'
          }
        },
        actualContribution: {
          type: 'number',
          minimum: 0,
          'x-schema-form': {
            fieldAddonLeft: '£'
          }
        },
        cost: fieldDefinitionService.number.currencyField(),

        workings: {
          type: 'object',
          title: 'Breakdown',
          properties: workingsFields,
          required: [
            'ageLevel',
            'capitalTariff',
            'totalCapital',
            'grossIncome',
            'universalCreditIncome',
            'disregards',
            'netIncome',
            'personalLivingAllowance',
            'totalCosts'
          ]
        }
      },
      required: ['workings']
    };
  };

}

KirkleesCareAssessmentService.$inject = ['kirkleesCareAssessmentConstants', 'fieldDefinitionService', 'numberUtils', 'careAssessmentService'];

angular.module('kerp-forms.forms').service('kirkleesCareAssessmentService', KirkleesCareAssessmentService);
